export type ReadonlyAccountsEndpoints = {
    readonly AuthenticateUser: string;
    readonly GetUsers: string;
    readonly GetUserById: string;
    readonly CreateUser: string;
    readonly DeleteUser: string;
    readonly SendResetPasswordLink: string;
    readonly GetUserFromResetToken: string;
    readonly ResetPassword: string;
    readonly ChangePassword: string;
    readonly addUpdateUserSiteConnection: string;
    readonly ValidateOTP : string;
    readonly SendOTP :string;
    readonly ResendOTP :string;
}

const controller = 'api/Accounts';

const AccountsEndpoints: ReadonlyAccountsEndpoints = {
    AuthenticateUser: `api/Users/AuthenticateUser`,
    GetUsers: `api/Users/GetUsers`,
    ValidateOTP: `api/Users/ValidateOTP`,
    SendOTP: `api/Users/SendOTP`,
    ResendOTP: `api/Users/ResendOTP`,
    GetUserById: `api/Users/GetUserById`,
    CreateUser: `api/Users/CreateUser`,
    DeleteUser: `api/Users/DeleteUser`,
    SendResetPasswordLink: `api/Users/SendResetPasswordLink`,
    GetUserFromResetToken: `api/Users/GetUserFromResetToken`,
    ResetPassword: `api/Users/ResetPassword`,
    ChangePassword: `api/Users/ChangePassword`,
    addUpdateUserSiteConnection: `api/Sites/AddUpdateUserSiteConnection`,
};

export { AccountsEndpoints };